/*
 * @Author: your name
 * @Date: 2021-03-08 13:36:11
 * @LastEditTime: 2021-04-13 15:02:51
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/store/getters.js
 */
const getters = {
  tag: state => state.tags.tag,
  website: state => state.common.website,
  user: state => state.user.user,
  theme: state => state.common.theme,
  themeName: state => state.common.themeName,
  isShade: state => state.common.isShade,
  isCollapse: state => state.common.isCollapse,
  keyCollapse: (state, getters) => getters.screen > 1 ? getters.isCollapse : false,
  screen: state => state.common.screen,
  isLock: state => state.common.isLock,
  isFullScreen: state => state.common.isFullScreen,
  lockPasswd: state => state.common.lockPasswd,
  tagList: state => state.tags.tagList,
  tagWel: state => state.tags.tagWel,
  access_token: state => state.user.access_token,
  refresh_token: state => state.user.refresh_token,
  expires_in: state => state.user.expires_in,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  dicts: state => state.user.dicts,
  menu: state => state.user.menu,
  menuAll: state => state.user.menuAll,
  shopId: state => state.common.shopId,
  shoppingCartList: state => state.common.shoppingCartList,
  isSuccessView: state => state.common.isSuccessView,
};
export default getters
